export const createFileAudioDataInitialState = {
  data: {
    tipoList: [],
    currentItemList: [],
  },
  loading: false,
};

export const currentFileAudioInitialState = {
  data: {
    announcementId: "",
    customerId: "",
    fileName: "",
    nome: "",
    tipo: "",
  },
  loading: false,
};
